import { render } from "./ClientList.vue?vue&type=template&id=6ed00b5b&scoped=true"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"

import "./ClientList.vue?vue&type=style&index=0&id=6ed00b5b&lang=css"
import "./ClientList.vue?vue&type=style&index=1&id=6ed00b5b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ed00b5b"

export default script